import React from 'react'

import { useInView } from 'react-cool-inview'

import { shape, string } from 'prop-types'

import useIterableInAppMessages from 'Pods/Shared/Hooks/useIterableInAppMessages'
import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'
import useTracker from 'Pods/Shared/Hooks/useTracker'

function ChallengeBannerSection({ images, url, alt, campaign }) {
  const { trackEvent } = useTracker()
  const pageConfig = usePageConfig()

  // The subscription banner this replaces was the homepage's only Iterable in-app mount.
  useIterableInAppMessages(pageConfig)

  const { observe } = useInView({
    threshold: 0.25,
    onEnter: ({ unobserve }) => {
      unobserve()
      trackEvent('homepage_challenge_banner_impression', { page_type: 'homepage', campaign })
    },
  })

  const handleClick = () => {
    trackEvent('homepage_challenge_banner_click', { page_type: 'homepage', campaign, element_url: url })
  }

  return (
    <section className="challenge-banner new-home-section" ref={observe}>
      <a className="challenge-banner__link" href={url} onClick={handleClick}>
        <picture>
          <source media="(min-width: 640px)" srcSet={images.desktop} width={2014} height={780} />
          <img
            className="challenge-banner__image"
            src={images.mobile}
            alt={alt}
            decoding="async"
            width={941}
            height={1672}
          />
        </picture>
      </a>
    </section>
  )
}

ChallengeBannerSection.propTypes = {
  images: shape({
    desktop: string.isRequired,
    mobile: string.isRequired,
  }).isRequired,
  url: string.isRequired,
  alt: string.isRequired,
  campaign: string.isRequired,
}

export default ChallengeBannerSection
